export const SITE_NAME = 'Alhaji Inusah Foundation';
export const SITE_URL = 'https://alhajiinusahfoundation.org';
export const DEFAULT_SITE_DESCRIPTION =
  'Latest activities, programs, and community updates from Alhaji Inusah Foundation.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const stripHtml = (value: string = ''): string =>
  value
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const truncateText = (value: string, maxLength: number): string => {
  if (value.length <= maxLength) {
    return value;
  }

  const truncated = value.slice(0, maxLength - 1).trimEnd();
  return `${truncated}...`;
};

export const getArticleDescription = (
  excerpt?: string,
  content?: string,
  maxLength: number = 160
): string => {
  const source = excerpt?.trim() || stripHtml(content || '') || DEFAULT_SITE_DESCRIPTION;
  return truncateText(source, maxLength);
};

export const toAbsoluteUrl = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  if (value.startsWith('//')) {
    return `https:${value}`;
  }

  if (value.startsWith('/')) {
    return `${SITE_URL}${value}`;
  }

  return `${SITE_URL}/${value.replace(/^\/+/, '')}`;
};
